import React, { useState, useEffect, useRef } from "react";
import { Select, Checkbox, Divider, Tag } from "antd";
import type { CheckboxProps, SelectProps } from "antd";

type TagRender = SelectProps["tagRender"];

interface Prop {
  options: any[];
  onChange?: (val: any, options: any[]) => void;
  onClick?: (val?: any) => void;
  placeholder?: string;
  fieldNames?: any;
  style?: any;
  value?: any[];
}
const SelectWithAll: React.FC<Prop> = (prop: Prop) => {
  const {
    options,
    onChange,
    onClick,
    placeholder = "请选择",
    fieldNames = { label: "label", value: "value" },
    style,
    value = [],
  } = prop;

  const [open, setOpen] = useState(false);
  const [allSelected, setAllSelected] = useState<boolean>(true);

  const selectValue = useRef<any[]>(value);

  const fieldNamesValue = fieldNames.value;

  const allCheckChange: CheckboxProps["onChange"] = (e: any) => {
    const checkVal = e.target.checked;
    let arr = [];
    setAllSelected(checkVal);
    if (checkVal) {
      arr = options ? options?.map((item: any) => item[fieldNamesValue]) : [];
    }
    // setSelectValue(arr);
    selectValue.current = arr;
    onChange && onChange(arr, formatOption(options));
  };
  const selectChange = (val: string[]) => {
    // setSelectValue(val);
    selectValue.current = val;
    const checkAll = options ? options.every((item: any) => val?.includes(item[fieldNamesValue])) : false;
    setAllSelected(checkAll);

    onChange && onChange(val, formatOption(options));
  };

  const formatOption = (options: any = []) => {
    return options.filter((item: any) => {
      return selectValue.current?.includes(item[fieldNamesValue]);
    });
  };

  const tagRender: TagRender = (props) => {
    // eslint-disable-next-line react/prop-types
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return allSelected ? (
      selectValue.current[0] == value ? (
        <Tag color="#1677ff" onMouseDown={onPreventMouseDown} onClick={() => setOpen(!open)}>
          全部
        </Tag>
      ) : (
        <span></span>
      )
    ) : (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginInlineEnd: 4 }}
        onClick={() => setOpen(!open)}
      >
        {label}
      </Tag>
    );
  };

  useEffect(() => {
    const isAll = options?.length
      ? options?.every((item: any) => {
          return value?.includes(item[fieldNamesValue]);
        })
      : false;
    setAllSelected(isAll);
  }, []);
  return (
    <Select
      mode="multiple"
      popupClassName="sro-select"
      placeholder={placeholder}
      options={options}
      showSearch={false}
      tagRender={tagRender}
      value={selectValue.current}
      fieldNames={fieldNames}
      onChange={selectChange}
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick();
      }}
      style={style}
      open={open}
      onDropdownVisibleChange={(visible) => setOpen(visible)}
      dropdownRender={(allSelectValue) => (
        <div>
          <div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }}>
            <Checkbox checked={allSelected} onChange={allCheckChange}>
              全选
            </Checkbox>
          </div>
          <Divider style={{ margin: "0" }} />
          {allSelectValue}
        </div>
      )}
    />
  );
};

export default SelectWithAll;
